import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { STORAGE_PREFIX } from '../constants';

export default function ExistingImagesGrid({
  saving,
  imgsKeep,
  onRemoveKeep,
  onMoveKeep,
}) {
  if (!imgsKeep?.length) return null;

  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="caption" color="text.secondary">
        Existing images (use ← → to reorder, ✕ to remove)
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
        {imgsKeep.map((key, idx) => {
          const src = STORAGE_PREFIX + key;

          return (
            <Box
              key={`${key}-${idx}`}
              sx={{
                position: 'relative',
                width: 64,
                height: 64,
                borderRadius: 1,
                overflow: 'hidden',
                border: '1px solid #e0e0e0',
              }}
            >
              <img
                src={src}
                alt={key}
                width={64}
                height={64}
                style={{ objectFit: 'cover', width: '100%', height: '100%' }}
              />

              {/* index badge (optional) */}
              <Box
                sx={{
                  position: 'absolute',
                  top: 2,
                  left: 2,
                  px: 0.5,
                  fontSize: 11,
                  bgcolor: 'rgba(0,0,0,0.55)',
                  color: 'white',
                  borderRadius: 0.5,
                }}
              >
                {idx + 1}
              </Box>

              {/* Move left */}
              <Tooltip title="Move left">
                <span>
                  <IconButton
                    size="small"
                    onClick={() => onMoveKeep(idx, idx - 1)}
                    disabled={saving || idx === 0}
                    sx={{
                      position: 'absolute',
                      bottom: 2,
                      left: 2,
                      bgcolor: 'white',
                      border: '1px solid #ddd',
                      '&:hover': { bgcolor: '#f5f5f5' },
                    }}
                  >
                    <ArrowBackIosNewIcon fontSize="inherit" />
                  </IconButton>
                </span>
              </Tooltip>

              {/* Move right */}
              <Tooltip title="Move right">
                <span>
                  <IconButton
                    size="small"
                    onClick={() => onMoveKeep(idx, idx + 1)}
                    disabled={saving || idx === imgsKeep.length - 1}
                    sx={{
                      position: 'absolute',
                      bottom: 2,
                      left: 34,
                      bgcolor: 'white',
                      border: '1px solid #ddd',
                      '&:hover': { bgcolor: '#f5f5f5' },
                    }}
                  >
                    <ArrowForwardIosIcon fontSize="inherit" />
                  </IconButton>
                </span>
              </Tooltip>

              {/* Remove */}
              <Tooltip title="Remove">
                <IconButton
                  size="small"
                  onClick={() => onRemoveKeep(idx)}
                  disabled={saving}
                  sx={{
                    position: 'absolute',
                    top: -8,
                    right: -8,
                    bgcolor: 'white',
                    border: '1px solid #ddd',
                    '&:hover': { bgcolor: '#f5f5f5' },
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}